"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaxSigningApi = void 0;

var WaxEventSource_1 = require("./WaxEventSource");

function getCurrentTime() {
  return Math.floor(new Date().getTime());
}

var WaxSigningApi = /*#__PURE__*/function () {
  function WaxSigningApi(waxSigningURL, waxAutoSigningURL, metricURL, returnTempAccount) {
    _classCallCheck(this, WaxSigningApi);

    this.waxSigningURL = waxSigningURL;
    this.waxAutoSigningURL = waxAutoSigningURL;
    this.metricURL = metricURL;
    this.returnTempAccount = returnTempAccount;
    this.waxEventSource = new WaxEventSource_1.WaxEventSource(waxSigningURL);
    this.metricURL = metricURL;
    this.returnTempAccount = returnTempAccount;
  }

  _createClass(WaxSigningApi, [{
    key: "logout",
    value: function logout() {
      this.user = null;
    }
  }, {
    key: "login",
    value: function login() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.user) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.loginViaWindow();

              case 3:
                if (!this.user) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", this.user);

              case 5:
                throw new Error("Login failed");

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "tryAutologin",
    value: function tryAutologin() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.user) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return this.loginViaEndpoint();

              case 5:
                return _context2.abrupt("return", true);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", false);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));
    }
  }, {
    key: "prepareTransaction",
    value: function prepareTransaction(transaction) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.canAutoSign(transaction)) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 3;
                return this.waxEventSource.openPopup("".concat(this.waxSigningURL, "/cloud-wallet/signing/"));

              case 3:
                this.signingWindow = _context3.sent;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "metricLog",
    value: function metricLog(name) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!(this.metricURL !== "")) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return fetch(this.metricURL, {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    name: name,
                    value: value,
                    tags: tags
                  })
                });

              case 4:
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                console.debug(_context4.t0); // do nothing

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 6]]);
      }));
    }
  }, {
    key: "signing",
    value: function signing(transaction, serializedTransaction) {
      var noModify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var feeFallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var startTime, res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.canAutoSign(transaction)) {
                  _context5.next = 13;
                  break;
                }

                _context5.prev = 1;
                startTime = getCurrentTime();
                _context5.next = 5;
                return this.signViaEndpoint(serializedTransaction, noModify, feeFallback);

              case 5:
                res = _context5.sent;
                _context5.next = 8;
                return this.metricLog("waxjs.metric.auto_signing", getCurrentTime() - startTime, []);

              case 8:
                return _context5.abrupt("return", res);

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](1);

              case 13:
                _context5.next = 15;
                return this.signViaWindow(serializedTransaction, this.signingWindow, noModify, feeFallback);

              case 15:
                return _context5.abrupt("return", _context5.sent);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 11]]);
      }));
    }
  }, {
    key: "proofWindow",
    value: function proofWindow(nonce, type, description) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var verifyUrl, referWindow;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                verifyUrl = "".concat(this.waxSigningURL, "/cloud-wallet/verify");
                _context6.next = 3;
                return this.waxEventSource.openEventSource(verifyUrl, {
                  type: "VERIFY",
                  nonce: nonce,
                  proof_type: type,
                  description: description
                });

              case 3:
                referWindow = _context6.sent;
                return _context6.abrupt("return", this.waxEventSource.onceEvent(referWindow, this.waxSigningURL, this.receiveVerfication.bind(this), undefined));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "loginViaWindow",
    value: function loginViaWindow() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var url, confirmationWindow;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                url = new URL("".concat(this.waxSigningURL, "/cloud-wallet/login/"));

                if (this.returnTempAccount) {
                  url.search = "returnTemp=true";
                } else {
                  url.search = "";
                }

                _context7.next = 4;
                return this.waxEventSource.openEventSource(url.toString());

              case 4:
                confirmationWindow = _context7.sent;
                return _context7.abrupt("return", this.waxEventSource.onceEvent(confirmationWindow, this.waxSigningURL, this.receiveLogin.bind(this), undefined));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "loginViaEndpoint",
    value: function loginViaEndpoint() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var url, response, data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                url = new URL("".concat(this.waxAutoSigningURL, "login"));

                if (this.returnTempAccount) {
                  url.search = "returnTemp=true";
                } else {
                  url.search = "";
                }

                _context8.next = 4;
                return fetch(url.toString(), {
                  credentials: "include",
                  method: "get"
                });

              case 4:
                response = _context8.sent;

                if (response.ok) {
                  _context8.next = 7;
                  break;
                }

                throw new Error("Login Endpoint Error ".concat(response.status, " ").concat(response.statusText));

              case 7:
                _context8.next = 9;
                return response.json();

              case 9:
                data = _context8.sent;

                if (!(data.processed && data.processed.except)) {
                  _context8.next = 12;
                  break;
                }

                throw new Error(data);

              case 12:
                return _context8.abrupt("return", this.receiveLogin({
                  data: data
                }));

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "signViaEndpoint",
    value: function signViaEndpoint(serializedTransaction) {
      var noModify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var feeFallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var controller, response, data;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                controller = new AbortController();
                setTimeout(function () {
                  return controller.abort();
                }, 5000);
                _context9.next = 4;
                return fetch("".concat(this.waxAutoSigningURL, "signing"), {
                  body: JSON.stringify({
                    freeBandwidth: !noModify,
                    feeFallback: feeFallback,
                    transaction: Object.values(serializedTransaction)
                  }),
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  method: "POST",
                  signal: controller.signal
                });

              case 4:
                response = _context9.sent;

                if (response.ok) {
                  _context9.next = 8;
                  break;
                }

                this.whitelistedContracts = [];
                throw new Error("Signing Endpoint Error ".concat(response.status, " ").concat(response.statusText));

              case 8:
                _context9.next = 10;
                return response.json();

              case 10:
                data = _context9.sent;

                if (!(data.processed && data.processed.except)) {
                  _context9.next = 14;
                  break;
                }

                this.whitelistedContracts = [];
                throw new Error("Error returned from signing endpoint: ".concat(JSON.stringify(data)));

              case 14:
                return _context9.abrupt("return", this.receiveSignatures({
                  data: data
                }));

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "receiveVerfication",
    value: function receiveVerfication(event) {
      if (event.data.type === "DENY") {
        throw new Error("User Denied Verification");
      }

      return Object.assign({}, event.data);
    }
  }, {
    key: "signViaWindow",
    value: function signViaWindow(serializedTransaction, window) {
      var noModify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var feeFallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var startTime, confirmationWindow;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                startTime = getCurrentTime();
                _context10.next = 3;
                return this.waxEventSource.openEventSource("".concat(this.waxSigningURL, "/cloud-wallet/signing/"), {
                  startTime: startTime,
                  feeFallback: feeFallback,
                  freeBandwidth: !noModify,
                  transaction: serializedTransaction,
                  type: "TRANSACTION"
                }, window);

              case 3:
                confirmationWindow = _context10.sent;
                return _context10.abrupt("return", this.waxEventSource.onceEvent(confirmationWindow, this.waxSigningURL, this.receiveSignatures.bind(this), "TX_SIGNED"));

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "receiveLogin",
    value: function receiveLogin(event) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _event$data, verified, userAccount, pubKeys, whitelistedContracts, isTemp, createData;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _event$data = event.data, verified = _event$data.verified, userAccount = _event$data.userAccount, pubKeys = _event$data.pubKeys, whitelistedContracts = _event$data.whitelistedContracts, isTemp = _event$data.isTemp, createData = _event$data.createData;

                if (verified) {
                  _context11.next = 3;
                  break;
                }

                throw new Error("User declined to share their user account");

              case 3:
                if (!(!userAccount || !pubKeys)) {
                  _context11.next = 5;
                  break;
                }

                throw new Error("User does not have a blockchain account");

              case 5:
                this.whitelistedContracts = whitelistedContracts || [];
                this.user = {
                  account: userAccount,
                  keys: pubKeys,
                  isTemp: isTemp,
                  createData: createData
                };
                return _context11.abrupt("return", true);

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "receiveSignatures",
    value: function receiveSignatures(event) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _event$data2, verified, signatures, whitelistedContracts, serializedTransaction, startTime;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(event.data.type === "TX_SIGNED")) {
                  _context12.next = 7;
                  break;
                }

                _event$data2 = event.data, verified = _event$data2.verified, signatures = _event$data2.signatures, whitelistedContracts = _event$data2.whitelistedContracts, serializedTransaction = _event$data2.serializedTransaction, startTime = _event$data2.startTime;

                if (!(!verified || !signatures)) {
                  _context12.next = 4;
                  break;
                }

                throw new Error("User declined to sign the transaction");

              case 4:
                this.whitelistedContracts = whitelistedContracts || [];

                if (startTime && startTime > 0) {
                  this.metricLog("waxjs.metric.manual_sign_transaction_time", getCurrentTime() - startTime, []);
                }

                return _context12.abrupt("return", {
                  serializedTransaction: serializedTransaction,
                  signatures: signatures
                });

              case 7:
                throw new Error("Unexpected response received when attempting signing: ".concat(JSON.stringify(event.data)));

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "canAutoSign",
    value: function canAutoSign(transaction) {
      var _this = this;

      var ua = navigator.userAgent.toLowerCase();

      if (ua.search("chrome") === -1 && ua.search("safari") >= 0) {
        return false;
      }

      return !transaction.actions.find(function (action) {
        return !_this.isWhitelisted(action);
      });
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(action) {
      return !!(this.whitelistedContracts && !!this.whitelistedContracts.find(function (w) {
        if (w.contract === action.account) {
          if (action.account === "eosio.token" && action.name === "transfer") {
            return w.recipients.includes(action.data.to);
          }

          return true;
        }

        return false;
      }));
    }
  }]);

  return WaxSigningApi;
}();

exports.WaxSigningApi = WaxSigningApi;